import { FormHandles } from '@unform/core'

import { Banner } from './Banner'
import { Product } from './Product'

// Single source of truth for the ad types that support the "add ad" flow.
// Add a new entry here and the gate, the type and the component map stay in sync.
export const addAdComponents = {
  product: Product,
  banner: Banner,
  banner_off_site: Banner
} satisfies Partial<
  Record<CampaignAdType, React.FC<AddAdComponentProps<FormHandles>>>
>

export type AddAdAllowedAdTypes = keyof typeof addAdComponents

export type AddAdProps<T = unknown> = {
  adType: AddAdAllowedAdTypes
} & AddAdComponentProps<T>
